import { needsFormulaGuard } from '@/lib/utils/csvFormulaGuard';

export function resolveColumnOrder(
  rows: Record<string, unknown>[],
  requested: string[],
): string[] {
  if (requested.length > 0) return requested;
  const seen = new Set<string>();
  for (const row of rows) {
    for (const key of Object.keys(row)) seen.add(key);
  }
  return Array.from(seen);
}

function escapeField(value: unknown): string {
  if (value === null || value === undefined) return '';
  let s = String(value);
  if (needsFormulaGuard(s)) {
    s = `'${s}`;
  }
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function rowsToCsv(rows: Record<string, unknown>[], columns: string[]): string {
  const header = columns.map(escapeField).join(',');
  const body = rows.map((row) => columns.map((c) => escapeField(row[c])).join(','));
  return [header, ...body].join('\r\n');
}
